import React, { Component } from 'react';
import { ComparisonTable } from '@eg/elements/ComparisonTable';
import { Price } from '@eg/elements/Price';
import { CheckIllustratedIcon } from '@eg/elements/Icons/CheckIllustratedIcon';
import { TooltipIcon } from '@eg/elements/TooltipIcon';
import { HouseGroundIcon } from '@eg/elements/Icons/HouseGroundIcon';

import "./ProductTable.scss"

class ProductTable extends Component {
  render(){
    return(
      <ComparisonTable>
        <thead>
          <tr>
            <th><h2 id="headlineTable">Internet-Schutzbrief (ISB)</h2></th>
            <th><HouseGroundIcon width={35} height={35}/></th>
          </tr>
        </thead>
        <tbody>
          <tr id="tableFirstRow">
            <th scope="row">Einmalbetrag</th>
            <td><Price id="price" value={6.90} suffix="im Jahr" /></td>
          </tr>
          <tr>
            <th scope="row">Versicherungsdauer</th>
            <td>1 Jahr</td>
          </tr>
          <tr>
            <th scope="row" id="table-cell">Weltweiter Schutz vor finanziellen Verlusten bei widerrechtlicher Verwendung von Kunden-/Kontodaten</th>
            <td><strong>15.000 € <wbr />Gesamt<wbr />versicherungs<wbr />summe</strong></td>
          </tr>
          <tr>
            <th scope="row">z.B. durch Phishing, Pharming, Skimming und Hacking</th>
            <td><CheckIllustratedIcon width={30} height={30}/></td>
          </tr>
          <tr>
            <th scope="row">
              bei bargeldlosen Bezahlvorgängen
              <TooltipIcon>
                Darunter versteht man E-Payment wie PayPal sowie Mobile-Payment.
              </TooltipIcon>
            </th>
            <td><CheckIllustratedIcon width={30} height={30}/></td>
          </tr>
          <tr>
            <th scope="row">beim Online- und E-Mail-Banking</th>
            <td><CheckIllustratedIcon width={30} height={30}/></td>
          </tr>
          <tr>
            <th scope="row">
              bei Bonussystemen und Onlinegutscheinen
              <TooltipIcon>
                Zu Bonussystemen zählen beispielsweise Payback oder WEB.Cent
              </TooltipIcon>
            </th>
            <td>500 €</td>
          </tr>
          <tr>
            <th scope="row">
              Nichtlieferung Online-Shopping
              <TooltipIcon>
                Die Ware muss von einem Verkäufer mit Geschäfts-/Wohnsitz
                innerhalb der EU bestellt worden sein. Bei der Nichtlieferung Online-Shopping
                gilt ein Selbstbehalt von 10 % des Kaufpreises mindestens 50 €.
              </TooltipIcon>
            </th>
            <td>3.000 €</td>
          </tr>
        </tbody>
      </ComparisonTable>
    )
  }
}

export default ProductTable;
